<div class="row" id="hrRow">
  <div class="col-md-12" id="hrDiv">
    <mat-card appearance="outlined" class="marB16" id="hrMatCard">
      <div *ngIf="editactivity">
        <button mat-icon-button class="close-button" [mat-dialog-close]="true" name="suitabilitydialogbtn" id="hrBtn">
          <mat-icon class="close-icon" color="warn" id="hrMatIcon">close</mat-icon>
        </button>
      </div>
      <div class="d-flex justify-content-between" style="margin-left: 18px; margin-top: 18px">
        <div class="txt_left">
          <h4 class="h3Header GreyDarkest text-1line marB16" id="hrAcName">
            {{ checkHrPanelInterviewObj.activityName }}
          </h4>
        </div>
        <div class="d-flex" style="margin-right: 18px">
          <span class="data-letters float-left marR6 listleft" id="hrInitials">{{
            loginUserName || 'NA' | initials
          }}</span>
          <h5 class="marginicon40 h5Header GreyLight marT8 float-right marR16" id="hrLogin">{{ loginUserName }}</h5>
          <span class="float-right marT4" id="hrDate">
            <span class="marginicon40 mainBodyTxt3 GreyLight blockInfo" *ngIf="timeModifiedOn; else elseTemplate">
              {{ timeModifiedOn | dateTransform }}
            </span>
            <ng-template class="mainBodyTxt3 GreyLight blockInfo" #elseTemplate id="hrTemp"> </ng-template>
          </span>
        </div>
      </div>
      <mat-card-content
        class="clearfix"
        *ngIf="isCollapsed"
        id="hrForm"
        [ngClass]="{ readActivityDisable: data && data.readflag }"
      >
        <form #f="ngForm" name="hrIntForm">
          <div *ngIf="this.testformValid(!f.invalid)"></div>
          <mat-form-field class="custom-form-field">
            <mat-label>Result</mat-label>
            <mat-select name="results" required [(value)]="referenceId" [disabled]="loader">
              <mat-option *ngFor="let ref of referenceActivities" [value]="ref.id" class="custom-select-option">
                {{ ref.description }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="hractivity" class="field-container">
            <mat-form-field class="custom-form-field">
              <mat-label>Role</mat-label>
              <input
                type="text"
                required
                matInput
                [formControl]="roleControl"
                [matAutocomplete]="auto"
                [readonly]="onEdit"
              />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option
                  (click)="selectedJobSubLevel = role.jobSubLevel"
                  *ngFor="let role of filteredRoles | async"
                  [value]="role.roleCapDesc"
                  class="custom-select-option"
                >
                  {{ role.roleCapDesc }}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="roleControl.hasError('invalidRole')">
                Please select a Role from the dropdown.
              </mat-error>
            </mat-form-field>
            <div class="custom-form-field" id="jslDiv">
              <label id="labelJsl" class="label-font">Job Sub Level</label>
              <div>{{ selectedJobSubLevel }}</div>
            </div>
          </div>
          <br />

          <mat-spinner id="panel-spinner" *ngIf="loader" class="centered"></mat-spinner>

          <div *ngIf="hractivity || hideValidate">
            <mat-form-field class="custom-form-field" id="hrchiplist">
              <mat-chip-grid #chipList name="activityempList">
                <mat-chip-row
                  *ngFor="let emp of empList"
                  [removable]="removable"
                  (removed)="remove(emp)"
                  id="{{ emp.empName }}"
                >
                  {{ emp.empName }}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip-row>
                <mat-chip-row id="{{ quitPanel.quitPanelGmail }}" *ngFor="let quitPanel of quitPanelistData">
                  <span style="color: red">
                    {{ quitPanel.quitPanelGmail }}
                  </span>
                </mat-chip-row>
                <input
                  id="chipList"
                  placeholder="{{ placeHold }}"
                  #empInput
                  [formControl]="inputCtrl"
                  [matAutocomplete]="auto"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="add($event)"
                />
              </mat-chip-grid>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                <mat-option *ngFor="let item of filteredEmp" [value]="item">
                  {{ item.empName }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div *ngIf="!hractivity && !hideValidate && checkHrPanelInterviewObj.activityId != 500107">
            <mat-form-field class="custom-form-field" id="hrEmp">
              <mat-chip-grid #chipList name="activitychiplist">
                <mat-chip-row
                  id="{{ emp.empName }}"
                  *ngFor="let emp of empList"
                  [removable]="removable"
                  (removed)="remove(emp)"
                >
                  {{ emp.empName }}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip-row>
                <mat-chip-row id="{{ quitPanel.quitPanelGmail }}" *ngFor="let quitPanel of quitPanelistData">
                  <span style="color: red">
                    {{ quitPanel.quitPanelGmail }}
                  </span>
                </mat-chip-row>
                <input
                  id="activityinput"
                  placeholder="{{ placeHold }}"
                  #empInput
                  [formControl]="empInputCtrl"
                  [(ngModel)]="hrEmpNo"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="add($event)"
                  [disabled]="loader"
                />
              </mat-chip-grid>
            </mat-form-field>
            <button class="primary-btn" (click)="validateId()" [disabled]="loader" id="ValBtn">Validate</button>
          </div>
          <mat-form-field class="custom-form-field">
            <textarea
              matInput
              rows="10"
              placeholder="Remarks"
              name="remarks"
              [(ngModel)]="remarks"
              [disabled]="loader"
              id="hrRemark"
            ></textarea>
          </mat-form-field>
          <mat-card appearance="outlined">
            <app-attachment
              name="hrpanelistupdate"
              (fileOutput)="receiveFileOutput($event)"
              [toggleBtn]="toggleBtn"
              [allowedTypes]="allowedTypes"
              [uploadType]="multiple"
              [editId]="editId"
              activityModuleFlag="true"
              [isMapFile]="isMapFile"
            ></app-attachment>
          </mat-card>

          <div class="row" *ngIf="!ifCoupled">
            <div class="row nomarLR padTB16">
              <div class="col-2">
                <button
                  mat-raised-button
                  class="primary-btn btnfullWdth"
                  id="saveBtn"
                  [disabled]="isSendDisable(f)"
                  (click)="send()"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="collapseAction m-auto">
        <div>
          <a href="javascript:void(0)" *ngIf="isCollapsed" class="icon x-24" (click)="showMoreLess()">
            <img src="../assets/images/icons/orange_icons/icon-collapse-arrow.png" alt="icon-collapse" />
          </a>
          <a href="javascript:void(0)" *ngIf="!isCollapsed" class="icon x-24" (click)="showMoreLess()">
            <img src="../assets/images/icons/orange_icons/icon-expand-arrow.png" alt="icon-expand" />
          </a>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
